(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@cainiaofe/cn-ui"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@cainiaofe/cn-ui", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["CN_UI_LOWCODE"] = factory(require("react"), require("@cainiaofe/cn-ui"), require("react-dom"));
	else
		root["CN_UI_LOWCODE"] = factory(root["React"], root["CNUI"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__90__) {
return 